import { ORDER as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    refreshBtn: false,
    align: 'center',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    column: [
      { label: LABELS.orderNumber, prop: 'orderNumber', search: true, width: 150 },
      { label: LABELS.orderLineNumber, prop: 'orderItemNumber', width: 80 },
      { label: LABELS.materialNumber, prop: 'materialNumber', search: true, width: 110 },
      { label: LABELS.materialName, prop: 'materialDesc', search: true, width: 150 },
      {
        label: LABELS.materialSpecifications,
        prop: 'materialSpecifications',
        search: true,
        width: 100
      },
      { label: LABELS.orderQuantity, prop: 'quantity', width: 100 },
      { label: LABELS.voucherNumber, prop: 'voucherNumber', width: 100, search: true },
      { label: LABELS.quantityOfDeliveryNoticesSent, prop: 'sendDeliveryNoteQuantity', width: 150 },
      {
        label: LABELS.deliveryDate,
        prop: 'deliveryDate',
        type: 'date',
        valueFormat: 'timestamp',
        format: 'yyyy-MM-dd',
        width: 100
      },
      { label: LABELS.factory, prop: 'factory', search: true, width: 70 },
      { label: LABELS.receiver, prop: 'receivedUser', width: 80 },
      { label: LABELS.requestForPurchaseRemaks, prop: 'remark', width: 85 },
      { label: LABELS.saleContract, prop: 'fbk49', search: true, width: 100 },
      { label: LABELS.productOrderNo, prop: 'fbk30', width: 120 },
      { label: LABELS.plateLengthModel, prop: 'fbk54', width: 100 }
    ]
  }
};
